var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty",class:{ small: _vm.hint }},[_c('img',{staticClass:"empty-img",attrs:{"src":require("../../../../assets/images/newService/empty.png"),"alt":"暂无数据"}}),(_vm.hint)?_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }